export interface Movie {
  id: string;
  title: string;
  /** tv = 电视剧, movie = 电影, variety = 综艺 */
  type: 'tv' | 'movie' | 'variety';
  region: string;
  year: number;
  category: string;
  cover: string;
  banner?: string;
  summary: string;
  cast: string[];
  director: string;
  status: string;
  rating: number;
  views: number;
  updatedAt: string;
  tags: string[];
  featured?: boolean;
}

export const typeLabels: Record<string, string> = {
  tv: '电视剧',
  movie: '电影',
  variety: '综艺',
};

export const moviesData: Movie[] = [
  {
    id: 'tv01',
    title: '长安夜行',
    type: 'tv',
    region: '内地',
    year: 2026,
    category: '古装',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20ancient%20Chinese%20palace%20city%20at%20night%20lit%20by%20red%20lanterns%2C%20lone%20silhouette%20walking%20a%20stone%20street%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20stylized%20illustration%2C%20highly%20detailed%20film%20promotional%20composition&width=400&height=600&seq=nn-tv-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20ancient%20Chinese%20imperial%20city%20at%20night%2C%20glowing%20red%20lanterns%20along%20a%20long%20majestic%20street%2C%20distant%20palace%20silhouette%20under%20a%20deep%20navy%20sky%2C%20misty%20atmosphere%2C%20warm%20orange%20light%20accents%2C%20stylized%20painterly%20illustration%2C%20no%20text%2C%20epic%20film%20key%20art&width=1600&height=900&seq=nn-banner-tv01&orientation=landscape',
    summary:
      '大唐贞观年间，长安城接连发生离奇命案，年轻的推官沈砚与被贬的前大理寺少卿联手追查，逐渐揭开一桩牵动朝堂二十年的旧案。随着线索层层深入，两人发现真相远比想象中残忍。',
    cast: ['陈墨白', '林知夏', '周砚舟', '许明珠'],
    director: '高云舒',
    status: '更新至第24集',
    rating: 8.7,
    views: 12860000,
    updatedAt: '2026-10-15',
    tags: ['悬疑', '古装', '权谋'],
    featured: true,
  },
  {
    id: 'tv02',
    title: '都市迷城',
    type: 'tv',
    region: '内地',
    year: 2026,
    category: '悬疑',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20rainy%20modern%20city%20skyline%20at%20night%20seen%20through%20a%20rain%20streaked%20window%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20mysterious%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20stylized%20illustration%2C%20noir%20film%20poster%20composition&width=400&height=600&seq=nn-tv-02&orientation=portrait',
    summary:
      '一座繁华都市连续出现身份不明的失踪者，刑警队长苏婉与数据分析师莫然从一串被抹除的监控记录入手，追踪到一个隐藏在正常生活之下的庞大网络。真相就在每个人身边。',
    cast: ['苏婉宁', '莫承宇', '顾晓岚', '秦牧'],
    director: '沈亦川',
    status: '更新至第18集',
    rating: 8.4,
    views: 9640000,
    updatedAt: '2026-10-14',
    tags: ['悬疑', '都市', '刑侦'],
  },
  {
    id: 'tv03',
    title: '星辰大海',
    type: 'tv',
    region: '内地',
    year: 2026,
    category: '科幻',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20lone%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%2C%20vast%20starry%20space%2C%20glowing%20blue%20and%20orange%20nebula%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20epic%20stylized%20illustration%2C%20sci-fi%20film%20promotional%20composition&width=400&height=600&seq=nn-tv-03&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20deep%20space%20with%20a%20massive%20ringed%20planet%20in%20the%20distance%2C%20a%20small%20spacecraft%20silhouette%2C%20glowing%20orange%20and%20navy%20nebula%20clouds%2C%20stars%20scattered%20across%20the%20frame%2C%20stylized%20painterly%20sci-fi%20illustration%2C%20no%20text%2C%20epic%20key%20art&width=1600&height=900&seq=nn-banner-tv03&orientation=landscape',
    summary:
      '人类首个深空世代飞船启航，目标是寻找宜居行星。船上的年轻导航员在一次意外中收到了来自百年前地球的信号，为了弄清真相，她必须在冰冷宇宙里做出改变整个人类命运的抉择。',
    cast: ['叶星遥', '陆铭', '韩若冰', '沈舟'],
    director: '苏黎',
    status: '更新至第30集',
    rating: 9.1,
    views: 15320000,
    updatedAt: '2026-10-13',
    tags: ['科幻', '太空', '冒险'],
    featured: true,
  },
  {
    id: 'tv04',
    title: '医者仁心',
    type: 'tv',
    region: '内地',
    year: 2025,
    category: '都市',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20warm%20hospital%20corridor%20at%20dusk%2C%20silhouette%20of%20a%20doctor%20in%20white%20coat%20by%20a%20bright%20window%2C%20hopeful%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20stylized%20illustration%2C%20professional%20drama%20poster&width=400&height=600&seq=nn-tv-04&orientation=portrait',
    summary:
      '急诊科主任医师白靖在一次次生死抢救中坚守初心，面对的不仅是疑难杂症，还有医疗资源、家庭与职业信仰的艰难抉择。一群年轻医生在他的带领下逐渐成长为真正的医者。',
    cast: ['白靖宇', '夏芷晴', '程亦扬', '何丽'],
    director: '李婉宁',
    status: '全40集',
    rating: 8.5,
    views: 7320000,
    updatedAt: '2026-10-11',
    tags: ['医疗', '都市', '情感'],
  },
  {
    id: 'tv05',
    title: '山河故人',
    type: 'tv',
    region: '内地',
    year: 2025,
    category: '年代',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20nostalgic%20rural%20village%20at%20golden%20sunset%20with%20wheat%20fields%20and%20an%20old%20train%2C%20warm%20sepia%20tones%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20painterly%20illustration%2C%20period%20drama%20film%20poster&width=400&height=600&seq=nn-tv-05&orientation=portrait',
    summary:
      '从上世纪八十年代到新世纪，一个普通家庭三代人随着时代浪潮起起落落。父辈的坚守、子辈的远行与孙辈的回望，交织成一幅跨越四十年的中国社会变迁画卷。',
    cast: ['赵国安', '王秀兰', '赵远航', '林小雨'],
    director: '贾承志',
    status: '全36集',
    rating: 8.9,
    views: 6810000,
    updatedAt: '2026-10-10',
    tags: ['年代', '家庭', '历史'],
  },
  {
    id: 'tv06',
    title: '权谋天下',
    type: 'tv',
    region: '内地',
    year: 2025,
    category: '古装',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20ancient%20Chinese%20throne%20room%20with%20golden%20dragon%20motifs%2C%20imperial%20silhouette%20in%20shadow%2C%20tense%20power%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20golden%20orange%20color%20grading%2C%20ornate%20stylized%20illustration%2C%20epic%20historical%20poster&width=400&height=600&seq=nn-tv-06&orientation=portrait',
    summary:
      '九子夺嫡，朝堂暗涌。寒门出身的谋士萧景行以一手惊天棋局游走于各方势力之间，他既要为家族复仇，又要在权力漩涡中护住心中的道义与挚爱。',
    cast: ['萧景行', '慕容雪', '谢云峥', '太子晟'],
    director: '高云舒',
    status: '全48集',
    rating: 9.0,
    views: 11240000,
    updatedAt: '2026-10-09',
    tags: ['古装', '权谋', '历史'],
  },
  {
    id: 'tv07',
    title: '青春不打烊',
    type: 'tv',
    region: '内地',
    year: 2026,
    category: '青春',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20sunlit%20high%20school%20campus%20with%20students%20cycling%20under%20blooming%20trees%2C%20youthful%20energetic%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20bright%20stylized%20illustration%2C%20youth%20drama%20poster&width=400&height=600&seq=nn-tv-07&orientation=portrait',
    summary:
      '五个性格迥异的高中生因为一场意外的社团重组走到一起，在笑声与眼泪中面对高考、友情与懵懂的爱情。他们约定，无论将来走多远，青春永远不打烊。',
    cast: ['林晓阳', '周子墨', '苏糖', '陈一诺'],
    director: '吴桐',
    status: '更新至第16集',
    rating: 8.2,
    views: 5430000,
    updatedAt: '2026-10-12',
    tags: ['青春', '校园', '成长'],
  },
  {
    id: 'tv08',
    title: '破晓追凶',
    type: 'tv',
    region: '内地',
    year: 2026,
    category: '刑侦',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20detective%20silhouette%20under%20a%20single%20streetlamp%20in%20misty%20dawn%2C%20crime%20scene%20tape%20in%20distance%2C%20tense%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20cold%20orange%20grading%2C%20gritty%20stylized%20illustration%2C%20crime%20thriller%20poster&width=400&height=600&seq=nn-tv-08&orientation=portrait',
    summary:
      '一桩尘封十五年的悬案因一名少年自首而重启，老刑警郝建军与新搭档方蕾抽丝剥茧，发现当年的每一个证人都隐瞒了同一个秘密。破晓之前，最黑暗的不是夜，而是人心。',
    cast: ['郝建军', '方蕾', '徐志远', '罗敏'],
    director: '郑凯',
    status: '更新至第20集',
    rating: 8.8,
    views: 8120000,
    updatedAt: '2026-10-08',
    tags: ['刑侦', '悬疑', '犯罪'],
  },
  {
    id: 'tv09',
    title: '烟火人间',
    type: 'tv',
    region: '内地',
    year: 2025,
    category: '都市',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20cozy%20old%20neighborhood%20alley%20at%20evening%20with%20warm%20food%20stalls%20and%20steam%2C%20families%20gathering%2C%20heartwarming%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20slice%20of%20life%20poster&width=400&height=600&seq=nn-tv-09&orientation=portrait',
    summary:
      '老城区拆迁在即，一间开了三十年的面馆里，来来往往的食客带着各自的故事。老板娘陈桂芳用一碗碗热汤，串起了街坊邻里的悲欢离合，也守住了这座城市最后的烟火气。',
    cast: ['陈桂芳', '老周', '李小满', '程亮'],
    director: '周牧',
    status: '全32集',
    rating: 8.6,
    views: 4980000,
    updatedAt: '2026-10-07',
    tags: ['都市', '生活', '温情'],
  },
  {
    id: 'tv10',
    title: '灵域传说',
    type: 'tv',
    region: '内地',
    year: 2026,
    category: '玄幻',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20mystical%20ancient%20mountain%20peak%20with%20glowing%20runes%20and%20flying%20swords%2C%20ethereal%20mist%2C%20fantasy%20energy%20swirls%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20epic%20stylized%20illustration%2C%20fantasy%20drama%20poster&width=400&height=600&seq=nn-tv-10&orientation=portrait',
    summary:
      '少年云澈自幼被视为废灵根，却意外唤醒上古灵域之力。为查明父母失踪之谜，他踏上修炼之路，在正邪交锋与门派恩怨中，一步步揭开灵域背后足以颠覆三界的真相。',
    cast: ['云澈', '苏青璃', '墨无痕', '白羽'],
    director: '公孙策',
    status: '更新至第28集',
    rating: 8.3,
    views: 8960000,
    updatedAt: '2026-10-06',
    tags: ['玄幻', '仙侠', '冒险'],
  },
  {
    id: 'tv11',
    title: '逆风翻盘',
    type: 'tv',
    region: '内地',
    year: 2025,
    category: '励志',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20determined%20young%20figure%20looking%20up%20at%20a%20towering%20city%20skyline%20at%20sunrise%2C%20hopeful%20uplifting%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20inspirational%20drama%20poster&width=400&height=600&seq=nn-tv-11&orientation=portrait',
    summary:
      '小镇青年方野带着一身债务来到大城市，从外卖员做起，凭着一股不服输的韧劲在互联网创业浪潮中几经沉浮。跌入谷底后，他重新出发，用最笨的办法赢回了属于自己的机会。',
    cast: ['方野', '沈曼', '高翔', '王小胖'],
    director: '刘一鸣',
    status: '全38集',
    rating: 8.1,
    views: 6120000,
    updatedAt: '2026-10-05',
    tags: ['励志', '都市', '创业'],
  },
  {
    id: 'tv12',
    title: '双面律师',
    type: 'tv',
    region: '港台',
    year: 2026,
    category: '律政',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20elegant%20lawyer%20silhouette%20in%20a%20grand%20courthouse%20hall%2C%20dramatic%20shafts%20of%20light%2C%20tense%20legal%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20legal%20drama%20poster&width=400&height=600&seq=nn-tv-12&orientation=portrait',
    summary:
      '天才辩护律师程亦正从不败诉，却在一桩看似普通的案件中发现委托人另有隐情。当职业道德与内心正义激烈碰撞，他决定赌上职业生涯，去揭开法庭之外的另一场博弈。',
    cast: ['程亦正', '林立雯', '郑启铭', '苏晴'],
    director: '陈国华',
    status: '更新至第22集',
    rating: 8.7,
    views: 5780000,
    updatedAt: '2026-10-04',
    tags: ['律政', '悬疑', '都市'],
  },
  {
    id: 'tv13',
    title: '海上繁花',
    type: 'tv',
    region: '内地',
    year: 2025,
    category: '民国',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%201930s%20Shanghai%20bund%20skyline%20at%20dusk%2C%20elegant%20woman%20in%20qipao%20looking%20at%20the%20river%2C%20romantic%20nostalgic%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20period%20romance%20poster&width=400&height=600&seq=nn-tv-13&orientation=portrait',
    summary:
      '三十年代的上海滩，留洋归来的千金小姐顾繁花接手家族商行，在动荡时局中周旋于各方势力。她与记者沈之遥相爱，却因时代的洪流一次次面临生离死别。',
    cast: ['顾繁花', '沈之遥', '陆慕白', '许丽珠'],
    director: '张曼',
    status: '全42集',
    rating: 8.5,
    views: 7460000,
    updatedAt: '2026-10-03',
    tags: ['民国', '爱情', '年代'],
  },
  {
    id: 'tv14',
    title: '未来纪元',
    type: 'tv',
    region: '欧美',
    year: 2026,
    category: '科幻',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20futuristic%20neon%20metropolis%20with%20flying%20vehicles%20and%20holographic%20displays%2C%20soaring%20skyscrapers%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20sleek%20stylized%20illustration%2C%20sci-fi%20series%20poster&width=400&height=600&seq=nn-tv-14&orientation=portrait',
    summary:
      '公元2147年，人类意识可以上传云端，社会被少数科技巨头掌控。一名底层数据修复师偶然发现系统里藏着一群"被删除的人"，为唤醒真相，他成为整个纪元最危险的逃亡者。',
    cast: ['里昂·凯恩', '玛雅·索恩', '德里克·韦恩', '艾拉'],
    director: '诺亚·布莱克',
    status: '更新至第10集',
    rating: 8.9,
    views: 9340000,
    updatedAt: '2026-10-02',
    tags: ['科幻', '反乌托邦', '悬疑'],
  },
  {
    id: 'tv15',
    title: '家有喜事',
    type: 'tv',
    region: '内地',
    year: 2025,
    category: '喜剧',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20cheerful%20multi%20generation%20family%20gathered%20around%20a%20festive%20dining%20table%2C%20colorful%20lanterns%2C%20joyful%20warm%20mood%2C%20no%20text%2C%20bright%20playful%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20cartoon%20stylized%20illustration%2C%20family%20comedy%20poster&width=400&height=600&seq=nn-tv-15&orientation=portrait',
    summary:
      '三代同堂的孙家永远热闹非凡：爷爷爱较真、爸妈爱拌嘴、孩子们各有心�事。一场突如其来的搬家计划，让这个普通家庭笑料百出，也重新找回了彼此的牵挂。',
    cast: ['孙大明', '刘桂香', '孙浩', '孙甜甜'],
    director: '冯乐',
    status: '全30集',
    rating: 8.0,
    views: 4210000,
    updatedAt: '2026-10-01',
    tags: ['喜剧', '家庭', '温情'],
  },
  {
    id: 'mv01',
    title: '孤星救援',
    type: 'movie',
    region: '内地',
    year: 2026,
    category: '动作',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20rugged%20rescuer%20standing%20on%20a%20cliff%20edge%20above%20stormy%20seas%2C%20helicopter%20in%20distance%2C%20heroic%20tense%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20action%20film%20poster&width=400&height=600&seq=nn-mv-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20action%20banner%20of%20a%20rescue%20helicopter%20flying%20through%20a%20raging%20storm%20over%20a%20dark%20ocean%2C%20lightning%20illuminating%20huge%20waves%2C%20a%20lone%20boat%20below%2C%20stylized%20painterly%20illustration%2C%20deep%20navy%20and%20orange%20color%20grading%2C%20no%20text%2C%20epic%20film%20key%20art&width=1600&height=900&seq=nn-banner-mv01&orientation=landscape',
    summary:
      '一艘科考船在风暴中失联，前特种兵出身的救援队长孤身深入无人海域。面对滔天巨浪和未知的深海威胁，他必须在有限时间内救出同伴，而这场救援远不止表面看起来那么简单。',
    cast: ['吴刚强', '林菲', '郑海', '田野'],
    director: '麦家辉',
    status: '高清',
    rating: 8.4,
    views: 10230000,
    updatedAt: '2026-10-15',
    tags: ['动作', '冒险', '灾难'],
    featured: true,
  },
  {
    id: 'mv02',
    title: '深海回响',
    type: 'movie',
    region: '欧美',
    year: 2026,
    category: '科幻',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20deep%20sea%20submersible%20diving%20toward%20a%20glowing%20mysterious%20abyss%2C%20bioluminescent%20creatures%2C%20eerie%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20cool%20orange%20grading%2C%20stylized%20illustration%2C%20sci-fi%20thriller%20poster&width=400&height=600&seq=nn-mv-02&orientation=portrait',
    summary:
      '深海探测器在海沟底部捕捉到一段无法解释的低频信号。一支国际科考队潜入深渊调查，却唤醒了沉睡亿万年的存在。当回响再次响起，人类才意识到自己并非海洋的主人。',
    cast: ['艾米丽·哈特', '丹尼尔·克鲁兹', '莉娜·佐藤', '奥马尔'],
    director: '詹姆斯·雷德',
    status: '高清',
    rating: 8.6,
    views: 8760000,
    updatedAt: '2026-10-14',
    tags: ['科幻', '惊悚', '冒险'],
  },
  {
    id: 'mv03',
    title: '追光者',
    type: 'movie',
    region: '内地',
    year: 2025,
    category: '剧情',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20runner%20sprinting%20toward%20a%20glowing%20sunrise%20on%20a%20mountain%20road%2C%20hopeful%20determined%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20inspirational%20drama%20poster&width=400&height=600&seq=nn-mv-03&orientation=portrait',
    summary:
      '一位因伤退役的长跑运动员回到家乡，发现曾经支教过的小学即将关闭。为了让孩子们被看见，他带着一群山里娃参加城市马拉松，跑出了一条通往更大世界的路。',
    cast: ['陈锐', '山花', '老支书', '李教练'],
    director: '秦川',
    status: '高清',
    rating: 8.8,
    views: 6540000,
    updatedAt: '2026-09-30',
    tags: ['剧情', '励志', '运动'],
  },
  {
    id: 'mv04',
    title: '江湖最后一剑',
    type: 'movie',
    region: '内地',
    year: 2026,
    category: '武侠',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20lone%20swordsman%20standing%20in%20falling%20snow%20on%20a%20bamboo%20bridge%2C%20drawn%20blade%20gleaming%2C%20solitary%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20cool%20orange%20grading%2C%20ink%20wash%20stylized%20illustration%2C%20wuxia%20film%20poster&width=400&height=600&seq=nn-mv-04&orientation=portrait',
    summary:
      '威震江湖三十年的剑圣决定归隐，却在封剑之夜遭遇昔日仇家上门。为了护住无辜的徒弟，他重提长剑。这一战，是他为江湖、也为自己挥出的最后一剑。',
    cast: ['独孤寒', '穆青', '雷震天', '苏娘'],
    director: '徐克明',
    status: '高清',
    rating: 8.9,
    views: 7830000,
    updatedAt: '2026-10-13',
    tags: ['武侠', '动作', '古装'],
  },
  {
    id: 'mv05',
    title: '时间褶皱',
    type: 'movie',
    region: '欧美',
    year: 2026,
    category: '科幻',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20scientist%20silhouette%20before%20a%20giant%20fractured%20clock%20face%20floating%20in%20a%20void%2C%20fragmented%20reality%20shards%2C%20surreal%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20mind%20bending%20sci-fi%20poster&width=400&height=600&seq=nn-mv-05&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20fractured%20reality%20with%20a%20giant%20dissolving%20clock%20floating%20in%20a%20dark%20void%2C%20shards%20of%20space%20and%20time%20scattered%20around%2C%20glowing%20orange%20and%20navy%20energy%2C%20stylized%20painterly%20illustration%2C%20no%20text%2C%20surreal%20sci-fi%20key%20art&width=1600&height=900&seq=nn-banner-mv05&orientation=landscape',
    summary:
      '物理学家顾南在一次实验事故中意外获得了"看见"时间褶皱的能力。为了阻止一场注定发生的灾难，他在无数条时间线之间反复穿梭，却发现每一次改变都在制造新的悲剧。',
    cast: ['顾南', '伊芙·林', '托马斯', '周毓'],
    director: '克里斯·诺兰',
    status: '高清',
    rating: 9.2,
    views: 13480000,
    updatedAt: '2026-10-12',
    tags: ['科幻', '悬疑', '烧脑'],
    featured: true,
  },
  {
    id: 'mv06',
    title: '归途',
    type: 'movie',
    region: '内地',
    year: 2025,
    category: '剧情',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20old%20van%20driving%20down%20a%20long%20empty%20desert%20highway%20toward%20a%20warm%20sunset%2C%20lonely%20wandering%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20road%20movie%20poster&width=400&height=600&seq=nn-mv-06&orientation=portrait',
    summary:
      '多年未归的老人在得知老伴病重后，执意独自开车穿越半个中国回家。一路上他遇到了形形色色的陌生人，也在一次次停留中，重新拾起了被岁月掩埋的记忆与遗憾。',
    cast: ['高建国', '陈玉兰', '年轻旅客', '卡车司机'],
    director: '田壮',
    status: '高清',
    rating: 8.6,
    views: 4890000,
    updatedAt: '2026-09-28',
    tags: ['剧情', '公路', '温情'],
  },
  {
    id: 'mv07',
    title: '城市之光',
    type: 'movie',
    region: '港台',
    year: 2026,
    category: '犯罪',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20lone%20figure%20walking%20through%20a%20neon%20lit%20harbor%20city%20alley%20at%20night%2C%20wet%20reflections%2C%20noir%20crime%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20crime%20drama%20poster&width=400&height=600&seq=nn-mv-07&orientation=portrait',
    summary:
      '退休警察老麦在一桩连环抢劫案中发现了当年搭档死亡的真相。为了给兄弟一个交代，他重新走进了这座灯火通明却暗流涌动的城市，用最后的力气点亮了角落里的光。',
    cast: ['麦志强', '何美仪', '陈永昌', '阿豪'],
    director: '杜峰',
    status: '高清',
    rating: 8.7,
    views: 7120000,
    updatedAt: '2026-10-11',
    tags: ['犯罪', '动作', '剧情'],
  },
  {
    id: 'mv08',
    title: '龙纹密码',
    type: 'movie',
    region: '内地',
    year: 2026,
    category: '悬疑',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20ancient%20carved%20dragon%20stone%20door%20glowing%20with%20mysterious%20runes%20in%20a%20dark%20temple%2C%20adventure%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20adventure%20mystery%20poster&width=400&height=600&seq=nn-mv-08&orientation=portrait',
    summary:
      '一支考古队在西域古墓中发现了刻满龙纹的神秘石板，随之而来的却是接连失踪。年轻的密码学专家临危受命，必须在古老诅咒与贪婪人心之间，解开这段沉睡千年的密码。',
    cast: ['江黎', '苏牧', '胡教授', '娜仁'],
    director: '高云舒',
    status: '高清',
    rating: 8.3,
    views: 5670000,
    updatedAt: '2026-10-10',
    tags: ['悬疑', '冒险', '奇幻'],
  },
  {
    id: 'mv09',
    title: '荒原信使',
    type: 'movie',
    region: '欧美',
    year: 2025,
    category: '科幻',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20lone%20traveler%20in%20a%20long%20coat%20crossing%20a%20vast%20ruined%20post%20apocalyptic%20wasteland%2C%20distant%20ruins%2C%20desolate%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20post%20apocalyptic%20poster&width=400&height=600&seq=nn-mv-09&orientation=portrait',
    summary:
      '末世之后，世界只剩下零散的聚居地。一名独行的信使背负着连接各地的唯一希望，穿越危险的荒原运送重要物资。当旧世界的秘密随他一同抵达，每个人都必须重新选择相信。',
    cast: ['卡伊·雷德', '诺拉', '老探员', '机械师杰'],
    director: '马修·格兰特',
    status: '高清',
    rating: 8.5,
    views: 6210000,
    updatedAt: '2026-09-26',
    tags: ['科幻', '动作', '末世'],
  },
  {
    id: 'mv10',
    title: '你好，旧时光',
    type: 'movie',
    region: '内地',
    year: 2025,
    category: '爱情',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20young%20couple%20on%20a%20bicycle%20under%20golden%20autumn%20trees%20on%20an%20old%20campus%20road%2C%20nostalgic%20romantic%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20romance%20film%20poster&width=400&height=600&seq=nn-mv-10&orientation=portrait',
    summary:
      '毕业十年后的同学聚会上，当年错过彼此的两个人再次相遇。一叠泛黄的信件、一段未说完的告白，让那段被时间尘封的青春重新流动起来。原来有些人，从来没有真正走远。',
    cast: ['林嘉树', '苏念', '周航', '小雅'],
    director: '顾长川',
    status: '高清',
    rating: 8.2,
    views: 4380000,
    updatedAt: '2026-09-25',
    tags: ['爱情', '青春', '文艺'],
  },
  {
    id: 'mv11',
    title: '风暴之眼',
    type: 'movie',
    region: '欧美',
    year: 2026,
    category: '灾难',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20massive%20tornado%20towering%20over%20a%20small%20prairie%20town%2C%20storm%20chasers%20in%20the%20foreground%2C%20apocalyptic%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20disaster%20film%20poster&width=400&height=600&seq=nn-mv-11&orientation=portrait',
    summary:
      '一场史无前例的超级风暴逼近沿海城市，气象学家凯特带着团队逆风而上，只为争取最后的疏散时间。在自然的狂暴面前，人类的渺小与勇气同时被无限放大。',
    cast: ['凯特·马隆', '杰克·雷诺', '市长戴维斯', '气象员本'],
    director: '史蒂文·霍',
    status: '高清',
    rating: 8.1,
    views: 5320000,
    updatedAt: '2026-10-09',
    tags: ['灾难', '动作', '剧情'],
  },
  {
    id: 'mv12',
    title: '云端之城',
    type: 'movie',
    region: '内地',
    year: 2026,
    category: '奇幻',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20sky%20city%20floating%20among%20majestic%20clouds%20with%20waterfalls%20and%20flying%20whales%2C%20dreamlike%20fantasy%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20grand%20stylized%20illustration%2C%20fantasy%20adventure%20poster&width=400&height=600&seq=nn-mv-12&orientation=portrait',
    summary:
      '少女阿禾意外闯入漂浮在云端的失落之城，为找回被风带走的弟弟，她与一群奇特的伙伴踏上冒险。在这座由记忆与愿望编织的城市里，她渐渐明白了家真正的含义。',
    cast: ['阿禾', '风铃', '云伯', '小石头'],
    director: '田晓鹏',
    status: '高清',
    rating: 8.8,
    views: 6980000,
    updatedAt: '2026-10-08',
    tags: ['奇幻', '冒险', '动画'],
  },
  {
    id: 'mv13',
    title: '无声告白',
    type: 'movie',
    region: '内地',
    year: 2025,
    category: '剧情',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20quiet%20lakeside%20cabin%20at%20dusk%20with%20a%20lone%20figure%20gazing%20at%20the%20water%2C%20melancholic%20mysterious%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20quiet%20drama%20poster&width=400&height=600&seq=nn-mv-13&orientation=portrait',
    summary:
      '一个普通家庭的女儿突然失踪，母亲在寻找真相的过程中，发现了丈夫与孩子各自深藏的秘密。有些爱从未说出口，却沉重到足以压垮整个家。',
    cast: ['刘文珍', '陈建明', '陈思思', '王警官'],
    director: '曹静',
    status: '高清',
    rating: 8.6,
    views: 3960000,
    updatedAt: '2026-09-22',
    tags: ['剧情', '悬疑', '家庭'],
  },
  {
    id: 'mv14',
    title: '极限时速',
    type: 'movie',
    region: '欧美',
    year: 2026,
    category: '动作',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20supercar%20drifting%20through%20a%20neon%20lit%20street%20race%20at%20night%2C%20motion%20blur%20speed%20lines%2C%20adrenaline%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20sleek%20stylized%20illustration%2C%20action%20racing%20poster&width=400&height=600&seq=nn-mv-14&orientation=portrait',
    summary:
      '天才车手德里克出狱后被迫重返地下赛车的世界，只为偿还弟弟的债务。在那条没有规则的城市赛道上，速度既是他的武器，也是他唯一能掌握的命运。',
    cast: ['德里克·凯恩', '艾娃', '老黑', '科尔'],
    director: '贾斯汀·李',
    status: '高清',
    rating: 8.0,
    views: 5890000,
    updatedAt: '2026-10-07',
    tags: ['动作', '赛车', '犯罪'],
  },
  {
    id: 'mv15',
    title: '千面人生',
    type: 'movie',
    region: '港台',
    year: 2025,
    category: '犯罪',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20artwork%2C%20man%20in%20a%20suit%20surrounded%20by%20reflections%20of%20many%20different%20faces%20in%20mirrors%2C%20identity%20thriller%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20crime%20thriller%20poster&width=400&height=600&seq=nn-mv-15&orientation=portrait',
    summary:
      '一个擅长伪装身份的职业骗子，在最后一次任务中假扮成一位失踪的富商。随着他越来越融入这个身份，真实与谎言的边界开始崩塌，他分不清自己究竟是谁。',
    cast: ['高博文', '林慧', '陈老板', '阿成'],
    director: '杜峰',
    status: '高清',
    rating: 8.5,
    views: 4740000,
    updatedAt: '2026-09-20',
    tags: ['犯罪', '悬疑', '剧情'],
  },
  {
    id: 'va01',
    title: '欢乐大联盟',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '真人秀',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20colorful%20playful%20game%20show%20stage%20with%20spotlights%20and%20confetti%2C%20joyful%20energetic%20mood%2C%20no%20text%2C%20bright%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20fun%20stylized%20illustration%2C%20entertainment%20show%20poster&width=400&height=600&seq=nn-va-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20vibrant%20colorful%20television%20variety%20show%20stage%20with%20glowing%20spotlights%2C%20confetti%20and%20geometric%20LED%20screens%2C%20energetic%20festive%20atmosphere%2C%20warm%20orange%20and%20navy%20color%20grading%2C%20stylized%20illustration%2C%20no%20text&width=1600&height=900&seq=nn-banner-va01&orientation=landscape',
    summary:
      '集结各领域嘉宾的全民欢乐竞技秀，每期围绕一个爆笑主题展开游戏对抗。没有剧本、只有真实反应，在笑声中传递正能量，是全家一起追的周末下饭综艺。',
    cast: ['何老师', '娜娜', '大张', '小撒'],
    director: '牛牛综艺制作中心',
    status: '更新至20261015期',
    rating: 8.2,
    views: 8210000,
    updatedAt: '2026-10-15',
    tags: ['真人秀', '喜剧', '游戏'],
    featured: true,
  },
  {
    id: 'va02',
    title: '热血奔跑团',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '竞技',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20dynamic%20outdoor%20obstacle%20race%20with%20runners%20in%20colorful%20jerseys%2C%20stadium%20and%20city%20backdrop%2C%20energetic%20competitive%20mood%2C%20no%20text%2C%20bright%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20sports%20variety%20poster&width=400&height=600&seq=nn-va-02&orientation=portrait',
    summary:
      '六位固定嘉宾分组展开城市竞技，从街头寻宝到极限体能挑战，在奔跑中结识素人、完成任务。节目用最真实的汗水与默契，诠释了并肩作战的意义。',
    cast: ['雷子', '晓明', '恩恩', '郑恺'],
    director: '牛牛综艺制作中心',
    status: '更新至20261012期',
    rating: 8.4,
    views: 7640000,
    updatedAt: '2026-10-12',
    tags: ['竞技', '真人秀', '户外'],
  },
  {
    id: 'va03',
    title: '天籁之声',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '音乐',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20singer%20silhouette%20on%20a%20dramatic%20concert%20stage%20with%20golden%20light%20beams%20and%20soaring%20music%20notes%2C%20emotional%20powerful%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20music%20show%20poster&width=400&height=600&seq=nn-va-03&orientation=portrait',
    summary:
      '全国顶尖素人歌手同台竞演的殿堂级音乐舞台，四位重量级导师坐镇把关。没有炫技的花哨编排，只有最打动人心的一把好声音，让每一个平凡梦想被听见。',
    cast: ['导师团', '选手们'],
    director: '牛牛综艺制作中心',
    status: '更新至20261010期',
    rating: 8.6,
    views: 6980000,
    updatedAt: '2026-10-10',
    tags: ['音乐', '选秀', '竞演'],
  },
  {
    id: 'va04',
    title: '田园慢生活',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '生活',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20peaceful%20countryside%20farmhouse%20with%20vegetable%20gardens%2C%20smoke%20from%20a%20chimney%2C%20warm%20golden%20afternoon%20light%2C%20relaxing%20healing%20mood%2C%20no%20text%2C%20soft%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20lifestyle%20show%20poster&width=400&height=600&seq=nn-va-04&orientation=portrait',
    summary:
      '嘉宾们远离城市喧嚣，在一座山间小院过起自给自足的田园生活。种菜、做饭、待客、聊天，用最慢的节奏记录最简单也最治愈的日常，让观众跟着一起慢下来。',
    cast: ['黄老师', '何老师', '彭彭', '子枫'],
    director: '牛牛综艺制作中心',
    status: '更新至20261008期',
    rating: 8.5,
    views: 6120000,
    updatedAt: '2026-10-08',
    tags: ['生活', '真人秀', '治愈'],
  },
  {
    id: 'va05',
    title: '极限大挑战',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '竞技',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20team%20of%20contestants%20solving%20a%20giant%20puzzle%20in%20a%20futuristic%20arena%20at%20night%2C%20dramatic%20competitive%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20sleek%20stylized%20illustration%2C%20competition%20show%20poster&width=400&height=600&seq=nn-va-05&orientation=portrait',
    summary:
      '一档高强度团队挑战真人秀，嘉宾们要在限时内破解机关、完成体能与智力的双重考验。每一关都充满转折与反转，考验的不仅是实力，更是团队的信任与默契。',
    cast: ['渤哥', '红雷', '小猪', '艺兴'],
    director: '牛牛综艺制作中心',
    status: '更新至20261006期',
    rating: 8.3,
    views: 5870000,
    updatedAt: '2026-10-06',
    tags: ['竞技', '真人秀', '推理'],
  },
  {
    id: 'va06',
    title: '迷雾侦探社',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '推理',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20mysterious%20victorian%20study%20room%20with%20a%20magnifying%20glass%20and%20scattered%20clues%20under%20a%20single%20lamp%2C%20detective%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20mystery%20show%20poster&width=400&height=600&seq=nn-va-06&orientation=portrait',
    summary:
      '六位常驻侦探每期进入一个新的悬疑剧本，通过搜证、推理与角色扮演还原真相。烧脑的谜题设计加上嘉宾们的临场发挥，让每一起"案件"都意想不到。',
    cast: ['何老师', '撒老师', '白白', '小鸥'],
    director: '牛牛综艺制作中心',
    status: '更新至20261005期',
    rating: 8.8,
    views: 6530000,
    updatedAt: '2026-10-05',
    tags: ['推理', '悬疑', '真人秀'],
  },
  {
    id: 'va07',
    title: '爆笑脱口秀',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '喜剧',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20comedian%20at%20a%20microphone%20on%20a%20spotlight%20stage%20with%20an%20engaged%20audience%20silhouette%2C%20humorous%20energetic%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20comedy%20show%20poster&width=400&height=600&seq=nn-va-07&orientation=portrait',
    summary:
      '来自全国各地的脱口秀选手齐聚舞台，用最接地气的段子讲述生活的荒诞与温柔。没有煽情套路，只有真实的观察和爆笑的观点，让你笑着笑着就上头了。',
    cast: ['李诞', '呼兰', '庞博', '鸟鸟'],
    director: '牛牛综艺制作中心',
    status: '更新至20261003期',
    rating: 8.7,
    views: 5590000,
    updatedAt: '2026-10-03',
    tags: ['喜剧', '语言', '脱口秀'],
  },
  {
    id: 'va08',
    title: '巅峰歌者',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '音乐',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20two%20singers%20facing%20off%20on%20dual%20glowing%20stages%20with%20waveform%20visuals%2C%20intense%20musical%20battle%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20music%20competition%20poster&width=400&height=600&seq=nn-va-08&orientation=portrait',
    summary:
      '顶级歌手同台竞技的音乐竞演节目，每期围绕不同主题重新编曲演绎经典与新作。现场观众实时投票，神仙打架般的对决，让每一首歌都值得单曲循环。',
    cast: ['歌手们', '音乐合伙人'],
    director: '牛牛综艺制作中心',
    status: '更新至20261002期',
    rating: 8.6,
    views: 5310000,
    updatedAt: '2026-10-02',
    tags: ['音乐', '竞演', '舞台'],
  },
  {
    id: 'va09',
    title: '姐姐的舞台',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '音乐',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20group%20of%20confident%20women%20performing%20on%20a%20glowing%20stage%20with%20mirror%20and%20light%20effects%2C%20empowering%20vibrant%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20stage%20show%20poster&width=400&height=600&seq=nn-va-09&orientation=portrait',
    summary:
      '三十位来自不同领域的女性嘉宾重新集结，为舞台梦想再次出发。她们在训练与竞演中打破年龄与标签的束缚，用实力证明：乘风破浪的从来不只是青春。',
    cast: ['姐姐们'],
    director: '牛牛综艺制作中心',
    status: '更新至20261001期',
    rating: 8.5,
    views: 6080000,
    updatedAt: '2026-10-01',
    tags: ['音乐', '竞演', '成长'],
  },
  {
    id: 'va10',
    title: '巅峰对局',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '游戏',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20two%20teams%20competing%20in%20an%20esports%20arena%20with%20giant%20screens%20and%20colorful%20lighting%2C%20exciting%20competition%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20game%20show%20poster&width=400&height=600&seq=nn-va-10&orientation=portrait',
    summary:
      '明星与职业选手组队，在热门游戏中展开巅峰对决。节目不仅还原紧张刺激的赛事氛围，也展现了选手们台前幕后的策略博弈与团队情谊。',
    cast: ['明星战队', '职业选手'],
    director: '牛牛综艺制作中心',
    status: '更新至20260928期',
    rating: 8.1,
    views: 4760000,
    updatedAt: '2026-09-28',
    tags: ['游戏', '电竞', '竞技'],
  },
  {
    id: 'va11',
    title: '天天欢乐',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '综艺',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20cheerful%20tv%20studio%20set%20with%20colorful%20props%2C%20friendly%20hosts%20and%20a%20lively%20crowd%2C%20upbeat%20warm%20mood%2C%20no%20text%2C%20bright%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20daily%20show%20poster&width=400&height=600&seq=nn-va-11&orientation=portrait',
    summary:
      '每日陪伴观众的轻松综艺，涵盖趣味访谈、生活妙招、才艺互动等丰富板块。用最接地气的内容和最真诚的欢乐，记录普通人的生活百态。',
    cast: ['天天兄弟'],
    director: '牛牛综艺制作中心',
    status: '更新至20260926期',
    rating: 8.0,
    views: 4120000,
    updatedAt: '2026-09-26',
    tags: ['综艺', '访谈', '生活'],
  },
  {
    id: 'va12',
    title: '声临其境',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '配音',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20voice%20actor%20silhouette%20in%20a%20recording%20booth%20with%20sound%20waves%20and%20floating%20characters%2C%20dramatic%20atmospheric%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20voice%20show%20poster&width=400&height=600&seq=nn-va-12&orientation=portrait',
    summary:
      '演员与专业配音师同台，用声音重新演绎经典影视片段。看不到画面的舞台上，仅凭声音塑造角色，让观众重新认识"声"入人心的力量。',
    cast: ['声咖团'],
    director: '牛牛综艺制作中心',
    status: '更新至20260924期',
    rating: 8.4,
    views: 3870000,
    updatedAt: '2026-09-24',
    tags: ['配音', '竞演', '表演'],
  },
  {
    id: 'va13',
    title: '街舞燃爆',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '舞蹈',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20street%20dancer%20mid%20battle%20move%20in%20a%20dark%20arena%20with%20neon%20graffiti%20and%20spotlights%2C%20high%20energy%20urban%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20dance%20show%20poster&width=400&height=600&seq=nn-va-13&orientation=portrait',
    summary:
      '全球顶尖街舞舞者集结，以城市街区为舞台展开燃爆对决。节目聚焦街舞文化本身，用最纯粹的热爱与实力，让每一次 battle 都点燃全场。',
    cast: ['队长们', '舞者'],
    director: '牛牛综艺制作中心',
    status: '更新至20260922期',
    rating: 8.6,
    views: 4530000,
    updatedAt: '2026-09-22',
    tags: ['舞蹈', '竞技', '街舞'],
  },
  {
    id: 'va14',
    title: '浪漫旅行团',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '旅行',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20cozy%20travel%20scene%20with%20friends%20by%20a%20scenic%20lake%20at%20sunset%2C%20map%20and%20suitcases%2C%20warm%20romantic%20mood%2C%20no%20text%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20travel%20show%20poster&width=400&height=600&seq=nn-va-14&orientation=portrait',
    summary:
      '几对明星夫妻结伴出行，在旅途中记录真实的相处日常。有甜蜜、有拌嘴、有彼此扶持，节目用一段段旅程，讲述平凡生活里最长情的浪漫。',
    cast: ['夫妻团'],
    director: '牛牛综艺制作中心',
    status: '更新至20260920期',
    rating: 8.2,
    views: 3690000,
    updatedAt: '2026-09-20',
    tags: ['旅行', '真人秀', '情感'],
  },
  {
    id: 'va15',
    title: '圆桌漫谈',
    type: 'variety',
    region: '内地',
    year: 2026,
    category: '谈话',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20artwork%2C%20warm%20indoor%20setting%20with%20a%20round%20table%20and%20cups%20of%20tea%2C%20soft%20hanging%20lamp%2C%20thoughtful%20intellectual%20mood%2C%20no%20text%2C%20soft%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20grading%2C%20stylized%20illustration%2C%20talk%20show%20poster&width=400&height=600&seq=nn-va-15&orientation=portrait',
    summary:
      '一群人围坐圆桌，围绕文化、生活与社会话题展开真诚而松弛的漫谈。没有标准答案，只有不同视角的碰撞，在对话中看见更广阔的世界。',
    cast: ['文化嘉宾'],
    director: '牛牛综艺制作中心',
    status: '更新至20260918期',
    rating: 8.7,
    views: 3140000,
    updatedAt: '2026-09-18',
    tags: ['谈话', '文化', '思辨'],
  },
];